import PendenciaService from './../_services/PendenciaService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'

const state = {
  pendencias: [],
  erros: '',

}

const getters = {
  GET_PENDENCIAS : (state) => state.pendencias,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_PENDENCIAS : (state, { pendencias }) => {
    state.pendencias = pendencias
  },

 
  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },


}

const actions = {

  GET_PENDENCIAS : async ({ commit }) => {
      commit('SET_PENDENCIAS', { pendencias : []})
      commit('ERASE_ERROS')
      await PendenciaService.getPendencias()
      .then(response => {
        if (response.data.status) {
          var data = []
          var obj = response.data.pendencias
          Object.keys(obj).forEach(function (item) {
            //var array = { value: obj[item].id, text: obj[item].nm_municipio+'/'+obj[item].cd_uf}
            obj[item].selected = false
            data.push(obj[item])
          })
          commit('SET_PENDENCIAS', { pendencias : data })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      })
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Pendencia/_store/index.js